module.exports = __webpack_public_path__ + "560dfc443309cf9339abc898e308e3a7.woff2";